export enum Entitlements {
  AiAssistant = "ai_assistant",
  SmsDedicated = "sms_dedicated",
  PhoneService = "phone_service",
}
